module.exports = __webpack_public_path__ + "img/maintenance.d7164b25.webp";